import PropTypes from "prop-types";

import styles from "./header.module.css";

import { removeGender } from "@lib/formatString";

export function Header({ title, description }) {
  return (
    <header className={styles.container}>
      <h1 className={styles.title}>{removeGender(title)}</h1>
      {description && <p className={styles.description}>{description}</p>}
    </header>
  );
}

Header.propTypes = { title: PropTypes.string.isRequired, description: PropTypes.string };
